module.exports = __webpack_public_path__ + "img/headerlogo.42833333.png";